import React from "react"
import { graphql } from "gatsby"

// Hooks / Querys
import { QueryFragments } from "../GraphQl/queryFragments"

// Components
import { PageMeta } from "../components/pageMeta"
import BlockZone from "../components/blocks/blockZone"

const IndexPage = ({ data: { page } }) => {
  const { meta, pageBlocks } = page || {}
  return (
    <>
      <PageMeta {...meta} />
      {pageBlocks && <BlockZone {...pageBlocks} />}
    </>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query homePageQuery {
    page: sanityHomePage {
      meta {
        ...MetaCardFields
      }
      pageBlocks {
        ...BlockZoneBlocks
      }
    }
  }
`
